import { Button } from "@fronterahealth/frontera-ui-components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@fronterahealth/frontera-ui-components/ui/dialog";

import { ConflictDialogBody } from "@components/QaReview/PeerReview/ConflictDialogBody";
import { useApplyComment } from "@components/QaReview/hooks/useApplyComment";
import { useResolveItem } from "@components/QaReview/hooks/useResolveItem";
import { useReviewData } from "@components/QaReview/hooks/useReviewData";
import { useReviewFields } from "@components/QaReview/hooks/useReviewFields";
import { useReviewSession } from "@components/QaReview/hooks/useReviewSession";

export const ConflictDialog: React.FC = () => {
  const { state, dispatch } = useReviewSession();
  const { items } = useReviewData();
  const fieldsById = useReviewFields();
  const advance = state.conflictAdvance;
  const { apply } = useApplyComment({ advance });
  const { resolve, isResolving } = useResolveItem({ advance });

  const comment = items.find((item) => item.id === state.conflictCommentId);
  const fieldId = comment?.reportSectionField?.id;
  const close = () => dispatch({ type: "setConflictComment", commentId: null });

  if (!comment) return null;
  const isPending = isResolving(comment);

  return (
    // A pending resolve closes the dialog itself, and unmounting it first would skip the navigator advance.
    <Dialog open onOpenChange={(open) => !open && !isPending && close()}>
      <DialogContent className="sm:max-w-4xl">
        <DialogHeader>
          <DialogTitle>Can&apos;t apply this edit</DialogTitle>
        </DialogHeader>

        {comment.__typename === "ReportCommentType" && comment.baseValue != null && comment.proposedValue != null && (
          <ConflictDialogBody
            fieldType={fieldId ? fieldsById[fieldId]?.realField.fieldType : undefined}
            baseValue={comment.baseValue}
            proposedValue={comment.proposedValue}
            currentValue={(fieldId && fieldsById[fieldId]?.content) || ""}
          />
        )}

        <DialogFooter>
          <Button variant="outline" disabled={isPending} onClick={close}>
            Cancel
          </Button>
          {/* The card's checkmark always applies, so this closes the comment and keeps the current text. It
              closes the dialog only once the resolve succeeds: unmounting first would skip the navigator advance. */}
          <Button variant="outline" disabled={isPending} onClick={() => resolve(comment, close)}>
            Resolve without applying
          </Button>
          <Button
            disabled={isPending}
            onClick={() => {
              void apply(comment);
              close();
            }}
          >
            Apply anyway
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
